import { ref } from "vue";

import { DateUtils } from "@/utils/dateUtils";

import { DashboardService } from "@/services";

import { isLoading } from "@/shared/base.service";

import type { DashboardResponse } from "@/types/response/dashboard";

export function useDashboard() {
  const integrationDashboard = ref<DashboardResponse>({
    total_active: 0,
    total_inactive: 0,
    average_error_processed_lines: 0,
    average_success_processed_lines: 0,
    total_errors: 0,
    success_lines_per_day: {},
    success_lines_per_connector: {},
  });
  async function getIntegrationDashboard(
    initial_datetime?: string,
    final_datetime?: string
  ) {
    try {
      const now = new Date();
      const yesterday = new Date(now);
      yesterday.setDate(now.getDate() - 1);

      const initialDate = initial_datetime
        ? initial_datetime
        : DateUtils.formatDate(yesterday);

      const finalDate = final_datetime
        ? final_datetime
        : DateUtils.formatDate(now);

      const response = await DashboardService.GetIntegrationDashboard(
        initialDate,
        finalDate
      );

      if (response) integrationDashboard.value = response;

      return response;
    } catch (error) {
      console.error(error);
    }
  }

  return {
    isLoading,
    integrationDashboard,
    getIntegrationDashboard,
  };
}
